<form 
  [hidden]="showTermsConditions"
  [formGroup]="enrollInEft" 
  name="enrollInEft"  
  (ngSubmit)="enroll(email, policyId) "
>
  <ng-container *ngIf="isAcmic; else enrollEftForMA">
    <div class="row margin-vertical mv24">
      <div class="col text-center">
        <div class="mapfre pill-box d-flex" [formGroup]="enrollAccountType">
          <div class="pill pill-left">
            <input type="radio" id="optionone" class="pill-radio" name="bankType" value="CHECKING" formControlName="bankType" [checked]="accountType === 'CHECKING'" required>
            <label for="optionone" class="pill-label no-margin-bottom">{{'CHECKING_ACCOUNT' | translate}}</label>
          </div>
          <div class="pill pill-right">
            <input type="radio" id="optiontwo" class="pill-radio" name="bankType" value="SAVING" formControlName="bankType" [checked]="accountType === 'SAVING'" required>
            <label for="optiontwo" class="pill-label no-margin-bottom">{{'SAVING_ACCOUNT'| translate}}</label>
          </div>
        </div>
      </div>
    </div>
  </ng-container>  
  <ng-template #enrollEftForMA>    
    <div class="row margin-bottom mb24 mt-4 enroll-eft-epay-form">
      <div class="col text-center">
        <div class="mapfre pill-box d-flex" [formGroup]="enrollAccountType">
          <div class="pill pill-left">
            <input type="radio" id="optionone" class="pill-radio" name="bankType" value="CHECKING" formControlName="bankType" [checked]="accountType === 'CHECKING'" required>
            <label for="optionone" class="pill-label padding-vertical pv4 no-margin-bottom">{{'CHECKING_ACCOUNT' | translate}}</label>
          </div>
          <div class="pill pill-right">
            <input type="radio" id="optiontwo" class="pill-radio" name="bankType" value="SAVING" formControlName="bankType" [checked]="accountType === 'SAVING'" required>
            <label for="optiontwo" class="pill-label padding-vertical pv4 no-margin-bottom">{{'SAVING_ACCOUNT'| translate}}</label>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <div class="manage-autopay-header-sub-title mb-4" *ngIf="company === 'ACIC'">
    {{ 'EPAY_EDIT_ENROLL_PARA' | translate }}
  </div>  
  <app-imp-notice *ngIf="mode.includes('edit') && company !== 'TW'" [impText]='importantText'></app-imp-notice>
  <app-imp-notice *ngIf="mode === 'edit'" [impText]='importantAchEftText'></app-imp-notice>
  <app-manage-autopay-imp-notice *ngIf="mode === 'enroll-add' || mode === 'edit-acic-tw'"></app-manage-autopay-imp-notice>

  <div class="row enroll-eft-epay-form" [ngClass]="{'mass-check': !isAcmic}">
    <div class="col">
      <div 
        *ngFor="let input of inputs; index as index; " 
        class="input"
      >
        <div 
          *ngIf="index > 0 && inputs[index - 1].inputType === 'select'" 
          [style.marginTop.px]="topicDropdownHeight"
        ></div>
        <div 
          *ngIf="index > 0 && (inputs[index - 1].showErrorMsg || (inputs[index - 1].inputType === 'select' && isDeductionDateDisabled))" 
          [style.marginTop.px]="24">
        </div>

        <ng-container *ngIf="input.inputType === 'select'">
          <div class="ap-select-form">
            <label 
              class="select-label mb-0" 
              [class.active]="enrollInEft?.get(input.key)?.value && !isDeductionDateDisabledPayPlan"
              [class.disabled-field]="isDeductionDateDisabledPayPlan"
              (click)="isMobile && toggleDeductionTooltip($event)"
              [style.user-select]="isMobile ? 'none' : ''"
            >
              <span>Monthly deduction date</span>
              <app-info-tooltip
                #deductionTooltip
                *ngIf="isDeductionDateDisabledPayPlan"
                [content]="'Deductions follow your policy effective date. Dates on the 29th–31st deduct on the 28th.'"
                [align]="isMobile ? 'right' : 'left'"
                [edgeOffset]="isMobile ? 0 : 147">
              </app-info-tooltip>
            </label>
            <ng-select 
              [class.active]="enrollInEft?.get(input.key)?.value"
              [class.disabled-field]="isDeductionDateDisabledPayPlan"
              [items]="deductionDateOptions"
              bindLabel="label" 
              bindValue="label"
              [autofocus]="false" 
              [searchable]="false" 
              [clearable]="false" 
              [markFirst]="false" 
              placeholder="Select" 
              fixedPlaceholder="true"
              [dropdownPosition]="'bottom'"
              [formControlName]="input.key"
              (change)="onDeductionDateChange(input)"
              (close)="onDeductionDateClose($event)"
              (open)="onDeductionDateOpen($event)"
            > 
              <ng-template ng-option-tmp let-item="item" let-index="index">
                <div 
                  class="custom-option"
                  [ngClass]="{'highlight-selected': index === 0 && hoveredTopicIndex === null}"
                  (mouseenter)="hoveredTopicIndex = index"
                >
                  {{ item.label}}
                </div>
              </ng-template>
            </ng-select>
          </div>
        </ng-container>
        <div class="error-block warning-row" *ngIf= "input.inputType === 'select' && isDeductionDateDisabled">
            <span class="warning-icon"></span>
            {{ 'DEDUCTION_DATE_MESSAGE' | translate }}
        </div>

        <ng-container *ngIf="input.inputType === 'checkbox'">
          <div class="default-checkbox-label" [class.inactive]="!isTermsAndCondReview">
            <input 
              class="" 
              (change)="getStore($event)" 
              (click)="onCheckboxClick($event)"
              id="store-checkbox"  
              type="checkbox" 
              [formControlName]="input?.key"
            >
            <label class="ml-3" for="store-checkbox">
              {{ "I confirm that I have read and agree to the" | translate }}
              <a
                (click)="onTermsConditionsClick()"
                class="link-ap-terms-conditions nowrap"
              >{{ "autopay terms and conditions" | translate }}</a>.           
            </label>
          </div>
          <div class="error-block warning-row warn-terms-conditions-margin">
            <span class="warning-icon"></span>
              <span>{{ 'Please review the terms above to enable this checkbox.' | translate }}</span>
          </div>
        </ng-container>
        <ng-container *ngIf="input.inputType !== 'select' && input.inputType !== 'checkbox' ">
          <mapfre-validation 
            [input]="input" 
            [form]="enrollInEft" 
            [maximumLength]="9"
            [enableActiveStyle]="'true'"
          ></mapfre-validation>
        </ng-container>
      </div>
    </div>
  </div>
  
  <div class="row margin-top mt24 text-center enroll-eft-epay-form">
    <div class="col" *ngIf="!(mode === 'edit')">
      <mapfre-button
        [ngClass]="{'custom_loader':loader}"
        [additionalClasses]="'basic primary large-btn  mx-auto'"
        [disabledValue]="enrollInEft.valid && enrollAccountType.valid && isDeductionDateValid && storeCheck && !loader" 
        [inputType]="'submit'"
        [translateValue]="'ENROLL_LOWERCASE' | translate"
      ></mapfre-button>
    </div>

    <div class="col" *ngIf="(mode === 'edit')">
      <mapfre-button
        [ngClass]="{'custom_loader':loader}"
        [additionalClasses]="'basic primary large-btn  mx-auto'"
        [disabledValue]="enrollInEft.valid && enrollAccountType.valid && isDeductionDateValid && storeCheck && !loader" 
        [inputType]="'submit'"
        [translateValue]="'Edit' | translate"
      ></mapfre-button>
    </div>
  </div>
</form>
<ng-container *ngIf="showEnrollInfoConfirm">
  <mapfre-modal 
    [modalOptions]="enrollConfirmModalOptions" 
    [hideModal]="hideModal" 
    (closeModal)="resetHideModal($event)"
    (modalHide)="resetHideModal($event)"
  >
      <div class="modal-body eft-confirm-container-modal text-center">
          <figure class="text-center mb24 w-100">
              <img src="{{iconWarning}}" alt="icon warning" />
          </figure>
          <div class="autopay-title modal-title-width mb-4">
              Confirm the update for your {{ policyDetails[0]?.displayType?.label | lowercase }} policy 
                {{ policyDetails[0]?.policynumber.policyNumber }}
          </div>

          <app-imp-notice *ngIf="impText" [theme]="'red'" [impText]='impText'></app-imp-notice>

          <div class="modal-info-continue">
            {{ 'Do you still want to continue?' | translate }}
          </div>
          <hr class="devided-line mt-4 mb-4"/>
          <div class="btn-row-column unenroll-btn-dist">
            <div>
                <mapfre-button additionalClasses="ghost secondary large" (click)="hideModalAction($event)">
                    {{ 'CANCEL' | translate }}
                </mapfre-button>
            </div>
            <div>
                <mapfre-button 
                    additionalClasses="basic primary large text-capitalize" 
                    (click)="enroll(email, policyId, true)"
                >
                    {{ 'CONFIRM_CONTACT' | translate }}
                </mapfre-button>
            </div>                
          </div>
      </div>
  </mapfre-modal>
</ng-container> 

<app-autopay-terms-conditions
  *ngIf="showTermsConditions"
  (showTermsConditions)="onHideTermsConditions($event)"
></app-autopay-terms-conditions>

